import { useNavigate } from "react-router"
import { useRef } from "react"
import { FormikProps } from "formik"
import { CreateMobileAVResourceForm } from "../../resourcesTypes"
import { useApiMutation } from "../../../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../../../core/api/errorTypes"
import { createResource, ServiceCenterResourcesQuery } from "../../resourcesApi"

import {
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
} from "../../../../../../../constants/routes"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../../shared/components/pageHeader/PageHeaderApi"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../../shared/components/links/StandardBreadcrumbs"
import { CreateUpdateMobileAVForm } from "../../components/mobileAV/CreateUpdateMobileAVForm"

export function CreateMobileAV() {
    const navigate = useNavigate()
    const mobileAVFormRef = useRef<FormikProps<CreateMobileAVResourceForm>>(null)

    const { mutate } = useApiMutation(createResource, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({
                queryKey: [ServiceCenterResourcesQuery.SERVICE_CENTER_RESOURCES],
            })
            navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE)
        },
    })

    const createMobileAV = (value: CreateMobileAVResourceForm) => {
        mutate(value)
    }

    const handleSaveClick = () => {
        mobileAVFormRef.current?.submitForm()
    }

    return (
        <>
            <LocalizedStrict
                id="service-center-admin-organization-resources-create-mobile-av-title"
                attrs={{ title: true }}
            >
                <PageHeader
                    page={Page.SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE}
                    title="Create Mobile AV"
                    rightElement={
                        <LocalizedStrict id="support-create-company-create-button">
                            <StandardButton onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization">
                            <Breadcrumb>Organization</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-resources">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}>
                                Resources
                            </BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-resource-crate-mobile-av">
                            <Breadcrumb>Create Mobile AV</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <CreateUpdateMobileAVForm ref={mobileAVFormRef} onSubmit={createMobileAV} />
        </>
    )
}
